import React from 'react' // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom'

const BreadCrumbs = ({ languageContent, product, location }) => {

    return (
        <div className='bread-crumbs'>
            <div>
                <Link to={{ pathname: '/products', state: location.state }}>
                    {languageContent.allProducts}
                </Link>
                <span className='bread-crumbs-divider'>{'>'}</span>
            </div>
            <div>
                {`${product.brandName} ${product.genericName}`}
            </div>
        </div>
    )}

export default BreadCrumbs


// WEBPACK FOOTER //
// ./src/mi-app/products/BreadCrumbs.js